module.exports = __webpack_public_path__ + "img/apple-pay.9d43296b.svg";